<template>
  <div :class="usual ? 'btn-wrap' : 'btn-log-form-wrap'">
    <input
      :value="loading ? '' : text"
      type="submit"
      :class="{'btn-primary-big': !small, 'disabled': disabled}"
      class="btn-primary w-inline-block"
      @click="$emit('click')"
    >
    <Spinner v-if="loading" class="spinner" :size="small ? 'small' : 'medium'" />
  </div>
</template>

<script>
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'Submit',
    components: {
      Spinner,
    },
    props: {
      loading: Boolean,
      text: String,
      usual: Boolean,
      small: Boolean,
      disabled: Boolean,
    },
  };
</script>

<style lang="scss">
  .btn-log-form-wrap, .btn-wrap {
    position: relative;
    input {
      border: none;
      height: 48px;
    }

    input:focus {
      outline: none;
    }
  }

  .spinner {
    position: absolute;
    left: 50%;
    top: 10%;
    transform: translateX(-50%);
  }
</style>
